interface DealColumnConfig {
  label: string;
  variant: "link" | "text";
  columnKey?: string;
}

export const DEAL_NAME_COLUMN_KEY = "title";

const DEAL_COLUMNS: DealColumnConfig[] = [
  { label: "Asset Class", variant: "text" },
  { label: "Sub Asset Class", variant: "text" },
  { label: "Geography", variant: "link" },
  { label: "Currency", variant: "link", columnKey: "currency" },
  { label: "Vintage", variant: "link" }
];

export interface ColumnOption {
  key: string;
  label: string;
}

export interface ResolvedColumn {
  key: string;
  title: string;
  variant: "link" | "text";
}

export const resolveSupportedColumns = (defs: { key: string; title: string }[]): ResolvedColumn[] =>
  DEAL_COLUMNS.map((column) => {
    const key = column.columnKey ?? defs.find((def) => def.title.toLowerCase() === column.label.toLowerCase())?.key;
    return key ? { key, title: column.label, variant: column.variant } : null;
  }).filter((column): column is ResolvedColumn => column !== null);
